import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import { createTheme, ThemeProvider } from '@mui/material';
import { COLOR_PRIMARY, COLOR_SECONDARY } from './const';
import Program from './components/Program';
import SneakPeak from './components/SneakPeek';
import Contact from './components/Contact';
import ChannelTalkService from './ChannelTalkService';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />
  },
  {
    path: 'about',
    element: <About />
  },
  {
    path: 'program',
    element: <Program />
  },
  {
    path: 'sneak_peek',
    element: <SneakPeak />
  },
  {
    path: 'contact',
    element: <Contact />
  },
]);

const theme = createTheme({
  palette: {
    primary: {
      main: COLOR_PRIMARY,
    },
    secondary: {
      main: COLOR_SECONDARY,
    },
  },
});

ChannelTalkService.loadScript();
ChannelTalkService.boot({
  "pluginKey": "9e4ae23e-107a-4607-93b1-7edf8aaad239"
});

ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
